import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { ReservationComplete } from '../../components/ReservationComplete';

export const BusReservationComplete: React.FC = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const { logout } = useAuth();

    // API 응답 데이터 (reservationData) 또는 더미 데이터 (busInfo, departureTime)
    const state = location.state || {};
    const reservationData = state.reservationData;

    let busInfo = state.busInfo || '-';
    let departureTime = state.departureTime || '-';

    if (reservationData) {
        busInfo = reservationData.busName;
        departureTime = reservationData.departureTime.substring(0, 5);
    }

    const getWaitTime = (timeStr: string) => {
        if (!timeStr || timeStr === '-') return '-';
        try {
            const [hour, minute] = timeStr.split(':').map(Number);
            const date = new Date();
            date.setHours(hour);
            date.setMinutes(minute - 5);
            return `${String(date.getHours()).padStart(2, '0')}:${String(date.getMinutes()).padStart(2, '0')}`;
        } catch {
            return timeStr;
        }
    };

    const waitTime = getWaitTime(departureTime);

    const description = (
        <>
            <span className="highlight">{busInfo}</span>, {' '}
            <span className="highlight">{departureTime} 출발</span> 예약이 완료되었습니다.
        </>
    );

    const instruction = (
        <>
            <strong>{waitTime}</strong> 까지 버스 탑승장에 대기해주세요
        </>
    );

    const handleMain = () => {
        navigate('/selection');
    };

    const handleLogout = async () => {
        await logout();
    };

    return (
        <ReservationComplete
            title="별빛버스 승차 예약 완료"
            description={description}
            instruction={instruction}
            onMain={handleMain}
            onLogout={handleLogout}
        />
    );
};
